/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#fixHeadingHierarchy();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Fixes heading hierarchy: converts H3 to H2 when they are main topics
   * This is especially important for policy pages where topics should be H2, not H3
   */
  #fixHeadingHierarchy() {
    // Check if this is a policy page or page content
    const isPolicyPage = window.location.pathname.includes('/policies/') || 
                         this.closest('.rte') !== null ||
                         document.querySelector('main-page') !== null;
    
    if (isPolicyPage) {
      // Find all H3 elements
      const h3Elements = Array.from(this.querySelectorAll('h3'));
      
      h3Elements.forEach((h3) => {
        // Check if there's already an H1 on the page
        const hasH1 = document.querySelector('h1') !== null;
        
        // Check if this H3 is a main topic (not nested inside another heading structure)
        // Main topics are usually numbered (e.g., "1. Abrangência", "2. Prazo")
        const text = h3.textContent.trim();
        const isNumberedTopic = /^\d+\.\s/.test(text);
        
        // If it's a numbered topic and there's an H1, convert to H2
        // This ensures proper hierarchy: H1 (page title) > H2 (main topics) > H3 (subtopics)
        if (isNumberedTopic && hasH1) {
          const h2 = document.createElement('h2');
          h2.innerHTML = h3.innerHTML;
          h2.className = h3.className;
          h2.id = h3.id;
          // Preserve any data attributes
          Array.from(h3.attributes).forEach(attr => {
            if (attr.name.startsWith('data-')) {
              h2.setAttribute(attr.name, attr.value);
            }
          });
          h3.parentNode?.replaceChild(h2, h3);
        }
      });
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
